module.exports = __webpack_public_path__ + "img/tradespeople-respond.69e23687.jpg";